import { ProductType } from '@/data/types/Product';
import {
	ProductCardPLP,
	ProductCardPLPProps,
} from '@/components/content/CatalogEntryList/parts/ProductCardPLP';
import { useProductDetailsAddToCart } from '@/data/Content/ProductDetails';

interface WishListItemProps extends ProductCardPLPProps {
	productId: string;
	onDeleteFromWishList: (...product: ProductType[]) => (skipAlert?: boolean) => Promise<void>;
}

export const AccountFavoriteItem: React.FC<WishListItemProps> = ({
	product,
	productId,
	onDeleteFromWishList,
	...rest
}) => {
	const { addToCart } = useProductDetailsAddToCart(product);

	const handleOnDeleteFromWishList = async (event: any) => {
		event.preventDefault();
		await onDeleteFromWishList({
			...product,
			id: productId,
		})();
	};

	const handleOnAddToCart = async (event: any) => {
		event.preventDefault();
		await addToCart(event);
	};

	return (
		<ProductCardPLP
			isFavorite
			product={product}
			onToggleFavorite={handleOnDeleteFromWishList}
			onAddToCart={handleOnAddToCart}
			{...rest}
		/>
	);
};
